/* global cookiePolicy */
import ApplicationController from "application_controller.js";

export default class extends ApplicationController {

  debug = false;

  static values = {
    category: String,
    service: String,
  };

  connect() {
    this.log_function("connect");

    this.render();
  }

  render(){
    this.log_function("render");

    setTimeout(() => {
      if(this.show) {
        this.showElement();
      } else {
        this.hideElement();
      }
    }, 0);
  }

  acceptService(event){
    this.log_function("acceptService");

    // console.log(this.categoryValue);
    // console.log(this.serviceValue);

    this.dispatch("cookie-policy:consentEvent", {
      detail: {
        service: this.serviceValue,
        category: this.categoryValue,
      },
      prefix: false,
    });

    this.hideElement();
  }

  hideElement() {
    this.element.style.display = "none";
  }

  showElement() {
    this.element.style.display = "";
  }


  get show() {
    return !cookiePolicy.acceptedService(this.serviceValue, this.categoryValue);
  }

  disconnect(){
    this.log_function("disconnect");
  }
}
